export const CATEGORIES = {
  ENERGY: 'energy',
  GAS: 'gas',
  CERTIFICATES: 'property-rights',
};

export const TAB_LABELS = {
  [CATEGORIES.ENERGY]: 'Energia elektryczna',
  [CATEGORIES.GAS]: 'Gaz',
  [CATEGORIES.CERTIFICATES]: 'Prawa majątkowe',
};

export const WALLET_CATEGORIES = {
  ALL: 'all',
  ENERGY: 'energy',
  GAS: 'gas',
};

export const WALLET_TAB_LABELS = {
  [WALLET_CATEGORIES.ALL]: 'Wszystkie',
  [WALLET_CATEGORIES.ENERGY]: 'Energia elektryczna',
  [WALLET_CATEGORIES.GAS]: 'Gaz',
};

export const RANGES = {
  REGULAR: {
    FIVE_DAYS: '5D',
    ONE_MONTH: '1M',
    THREE_MONTHS: '3M',
    SIX_MONTHS: '6M',
    ONE_YEAR: '1Y',
    TWO_YEARS: '2Y',
    MAX: 'MAX',
  },
  CUSTOM: {
    FIVE_DAYS: '5D',
    ONE_MONTH: '1M',
    THREE_MONTHS: '3M',
    SIX_MONTHS: '6M',
    ONE_YEAR: '1Y',
    MAX: 'MAX',
  },
};

export const TICK_GRANULARITY = {
  MonthlyChart: {
    '5D': 1,
    '1M': 2,
    '3M': 3,
    '6M': 6,
    '1Y': 8,
    '2Y': 10,
    MAX: 12,
  },
  SpotMonthlyChart: {
    '5D': 1,
    '1M': 2,
    '3M': 5,
    '6M': 6,
    '1Y': 8,
    '2Y': 10,
    MAX: 12,
  },
  SpotIntradayChart: {
    '5D': 24,
    '1M': 96,
  },
  QuarterlyChart: {
    '5D': 1,
    '1M': 3,
    '3M': 5,
    '6M': 8,
    '1Y': 10,
    '2Y': 12,
    MAX: 15,
  },
  YearlyChart: {
    '5D': 2,
    '1M': 4,
    '3M': 8,
    '6M': 12,
    '1Y': 15,
    '2Y': 20,
    MAX: 30,
  },
};

export const UNITS = {
  PMEF_F: {
    tooltip: 'zł/toe',
    axis: 'PLN/toe'
  },
  default: {
    tooltip: 'zł/MWh',
    axis: 'PLN/MWh'
  }
};
export const getUnits = (contractType: string) => UNITS[contractType] || UNITS.default;
export const REGULAR_RANGE = Object.values(RANGES.REGULAR);
export const CUSTOM_RANGE = Object.values(RANGES.CUSTOM);
